/**
 * У��Ȩ��
 * @param token
 * @returns {*}
 */
export function authorization(code) {
    let permissionList = JSON.parse(localStorage.getItem("permissionList"));
    let permission = permissionList.find((x) => { return x.code == code; });
    return permission && permission.id > 0;
}